import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function listItem(theme: Theme): ComponentStyle {
  return {
    componentName: 'listItem',
    baseStyle: {
      borderBottom: `1px solid ${theme.colors.border}`,
      color: theme.colors.text,
      cursor: 'pointer',
      padding: `${theme.space.s} ${theme.space['2xs']}`,

      ['&:hover']: {
        backgroundColor: theme.colors.tableRowHover,
        color: theme.colors.text
      }
    },
    variants: {
      recentActivityItem: {
        cursor: 'default',

        ['&:hover']: {
          backgroundColor: 'inherit',
          color: 'inherit'
        }
      }
    }
  };
}
